// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ContentView__root___dOdvX","container":"ContentView__container___PFkt1","tabs":"ContentView__tabs___Jnm8N","leftSide":"ContentView__leftSide___qoOjd"};